import { TextField } from "@mui/material";

interface LastNameInputProps {
  disabled?: boolean;
  required?: boolean;
  lastName: string;
  showValidation?: boolean;
  onBlur?: () => void;
  setLastName?: (lastName: string) => void;
}

const LastNameInput = ({
  disabled,
  required,
  lastName,
  setLastName,
  showValidation = true,
  onBlur,
}: LastNameInputProps): React.JSX.Element => {
  const isInvalid = lastName.length === 0;
  const showError = showValidation && isInvalid;

  return (
    <TextField
      sx={{
        "& .MuiInputBase-root": {
          color: showError
            ? (theme) => theme.palette.error.main
            : isInvalid
              ? undefined
              : (theme) => theme.palette.success.main,
        },
      }}
      disabled={disabled}
      focused={lastName.length > 0}
      color="success"
      required={required}
      fullWidth
      type="text"
      id="LastNameInput"
      label="Nachname"
      variant="outlined"
      value={lastName}
      onChange={(e) => {
        if (setLastName) {
          setLastName(e.target.value);
        }
      }}
      onBlur={onBlur}
      error={showError}
      helperText={showError ? "Bitte gib deinen Nachnamen ein" : ""}
    />
  );
};

export default LastNameInput;
